export default __webpack_public_path__ + "d1c19e91b116afaf5b51a5ffdadd49a7.png";